import { createFileRoute } from '@tanstack/react-router';

import {
  qcTemplatesQueryOptions,
  workflowTemplateQueryOptions,
  WorkflowTemplateEditPage,
} from '@/features/workflows';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/workflows/$templateId')({
  staticData: { tours: ['workflows.editor', 'workflows.stage-settings'] },
  loader: async ({ context, params }) => {
    const [template] = await Promise.all([
      context.queryClient.query({
        ...workflowTemplateQueryOptions(params.storeId, params.templateId),
        staleTime: 'static',
      }),
      context.queryClient
        .query({ ...qcTemplatesQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return { crumb: template.name };
  },
  component: WorkflowTemplateEditPage,
});
